import { Box, styled } from '@mui/material';

export const StyledHighlightableTextNotification = styled(Box)({
  position: 'fixed',
  bottom: '24px',
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: '#1976d2',
  color: 'white',
  padding: '12px 24px',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  zIndex: 10000,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  fontSize: '14px',
  fontWeight: 500,
  animation: 'slideUp 0.3s ease-out',
  cursor: 'pointer',
});

export const StyledHighlightableToggle = styled(Box)({
  position: 'fixed',
  bottom: '24px',
  right: '24px',
  backgroundColor: 'white',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  zIndex: 10000,
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '8px',
});

export const StyledHighlightableTextContainer = styled('span')({
  display: 'inline',
  whiteSpace: 'pre-wrap',
  // Heading styles - using inline to keep split headings on same line
  '& .h1-text': {
    fontSize: '2em',
    fontWeight: 'bold',
    display: 'inline',
  },
  '& .h2-text': {
    fontSize: '1.5em',
    fontWeight: 'bold',
    display: 'inline',
  },
  '& .h3-text': {
    fontSize: '1.17em',
    fontWeight: 'bold',
    display: 'inline',
  },
  '& .h4-text': {
    fontSize: '1em',
    fontWeight: 'bold',
    display: 'inline',
  },
  '& .h5-text': {
    fontSize: '0.83em',
    fontWeight: 'bold',
    display: 'inline',
  },
  '& .h6-text': {
    fontSize: '0.67em',
    fontWeight: 'bold',
    display: 'inline',
  },
  // Bold text style
  '& .bold-text': {
    fontWeight: 'bold',
  },
  // Default text style
  '& .default-text': {
    display: 'inline',
  },
});

